import { env } from '../../utilities/envs';

/**
 * Parses `NEXT_PUBLIC_WORK_PERMIT_AUTH_KEYCLOAK_TENANTS` (comma-separated
 * Keycloak / NextAuth provider ids). Must stay in sync with `tenantProviders()` in
 * `tenantsProvider.ts`.
 *
 * @param raw - Raw env value (comma-separated list), or `undefined` when unset.
 * @returns Trimmed non-empty provider id segments.
 */
export function parseKeycloakTenantIdEnvList(
  raw: string | undefined,
): string[] {
  if (!raw) {
    return [];
  }

  return raw
    .split(',')
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0);
}

/**
 * Keycloak tenant provider ids registered in this Next.js build (same list NextAuth uses).
 *
 * @returns Copy of the parsed tenant id list from the current process env.
 */
export function getRegisteredKeycloakTenantIds(): string[] {
  return parseKeycloakTenantIdEnvList(
    env['NEXT_PUBLIC_WORK_PERMIT_AUTH_KEYCLOAK_TENANTS'],
  );
}

/**
 * Returns whether `id` is a registered NextAuth Keycloak provider for this deployment.
 *
 * @param id - Tenant / provider id returned from the hostname lookup API (must match env list exactly).
 * @returns `true` when `id` appears in `NEXT_PUBLIC_WORK_PERMIT_AUTH_KEYCLOAK_TENANTS`.
 */
export function isRegisteredKeycloakTenantId(id: string): boolean {
  return getRegisteredKeycloakTenantIds().includes(id);
}
